import React from 'react'
import { accentUtils, formHelper, insyteDate } from '../../services/HelperService'
import { AccentInsyteDateUnbound } from '../unbound/AccentInsyteDateUnbound';

// Bound calendar-date control (AccentFormCtrl type "insytedate").
//
// The entity member holds the "yyyy-MM-dd" string Breeze received for the server-side
// InsyteDate? property, and that is exactly what is written back on change, so the save
// payload never contains an ISO date-time and no time zone conversion can occur.
export class AccentInsyteDate extends React.Component {

    constructor(props) {
        super(props);

        this.refreshKey = 1;

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(value) {

        const originalValue = this.props.model.getValue();

        const newValue = insyteDate.normalize(value);

        if (insyteDate.equals(originalValue, newValue)) {
            return;
        }

        this.props.model.setValue(newValue);

        if (!accentUtils.isNull(this.props.model.options.onChange)) {
            this.props.model.options.onChange({ originalValue: originalValue, value: newValue });
        }

        this.props.model.modified();
    }

    render() {

        const disabled = formHelper.isControlReadOnly(this.props.model);

        const modelValue = insyteDate.normalize(this.props.model.getValue());

        return (
            <div className="accentDateCtrl accentInsyteDateCtrl">
                <div className="accentDateCtrl-date">
                    <AccentInsyteDateUnbound
                        key={this.refreshKey}
                        value={modelValue}
                        disabled={disabled}
                        required={this.props.model.required}
                        label={this.props.model.displayLabel}
                        min={this.props.model.options?.min}
                        max={this.props.model.options?.max}
                        dataTagName={this.props.model.options?.tagName}
                        onChange={this.handleChange}
                    />
                </div>
            </div>
        );
    }
}
